// Serializes a live GridStack instance into the DashboardConfig layout-item shape
// the backend persists ({ i, x, y, w, h, minW?, minH? }).
//
// We read `grid.engine.nodes` rather than calling `grid.save()`: save() omits any
// field left at its GridStack default (x/y default 0, w/h default 1), but the
// backend validates the PRESENCE of i, x, y, w and h — a widget dropped at the
// origin would serialize to `{ i }` alone and be rejected. Normalizing each node
// with explicit fallbacks guarantees every item carries the five required keys.
export function gridToLayout(grid) {
  const nodes = grid?.engine?.nodes ?? []
  // Skip nodes without a stable widget id — e.g. GridStack's transient drop
  // placeholder, which briefly lives in engine.nodes mid-drop before the real
  // widget replaces it. Serializing it would persist a junk `{ i: undefined }`.
  return nodes
    .filter((node) => typeof node.id === "string" && node.id.length > 0)
    .map((node) => {
      const item = {
        i: node.id,
        x: node.x ?? 0,
        y: node.y ?? 0,
        w: node.w ?? 1,
        h: node.h ?? 1,
      }
      // minW/minH are optional in the persisted shape; only carry them when the
      // node actually constrains its size, so we don't invent constraints.
      if (node.minW != null) item.minW = node.minW
      if (node.minH != null) item.minH = node.minH
      // Section band (CONEK-6788). Persist ONLY an explicit per-item override
      // (data-section-explicit), never the resolved/derived band in data-section
      // — widgets normally inherit the header above them at render, so baking a
      // derived value into the config would freeze that inheritance. Not a
      // GridStack field, so read it off the node's element.
      const section = node.el?.dataset?.sectionExplicit
      if (section) item.section = section
      return item
    })
}
